import React from "react";
import { Reveal } from "../shared/Reveal";

const SOLAR_INSTALLS = [
  { img: "/brand/solar/s5.jpg", label: "Large-Scale Commercial Rooftop", meta: "Full-roof array · Industrial site" },
  { img: "/brand/solar/s4.jpg", label: "Industrial Warehouse", meta: "Aerial view · Distribution facility" },
  { img: "/brand/solar/s2.jpg", label: "Coastal Industrial Roof", meta: "Seafront manufacturing site" },
  { img: "/brand/solar/s1.jpg", label: "High-Street Premises", meta: "Café & retail · Pitched roof" },
  { img: "/brand/solar/s3.jpg", label: "Multi-Unit & Mixed-Use", meta: "Residential terrace install" },
];

export default function SolarGallery({ go }) {
  return (
    <section id="solar-installs" className="solargallery">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">PROOF ON THE ROOF</Reveal>
        <Reveal className="h2" tag="div">Commercial Solar PV <span className="g">Installs.</span></Reveal>
        <Reveal className="lead" tag="p">Real projects, delivered. From large industrial rooftops to high-street premises — sized to measured demand and verified to keep performing.</Reveal>
        <div className="solargrid">
          {SOLAR_INSTALLS.map((it, i) => (
            <Reveal className={`sgitem${i === 0 ? " big" : ""}`} tag="div" key={it.img} style={{ transitionDelay: `${i * 0.07}s` }} data-testid={`solar-install-${i}`}>
              <img src={it.img} alt={it.label} loading="lazy" />
              <div className="sgcap">
                <div className="sglabel">{it.label}</div>
                <div className="sgmeta">{it.meta}</div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal className="sgcta" tag="div">
          <a onClick={() => go("contact")} className="btn" data-testid="solar-gallery-cta">Discuss Your Solar PV Project</a>
        </Reveal>
      </div>
    </section>
  );
}
